import { History, HistoryEntry } from "graphql/types"

import {
  Box,
  Card,
  CardContent,
  CardHeader,
  ImageList,
  ImageListItem,
  Typography,
} from "@mui/material"
import { PersonTitleBox } from "components/PersonTitleBox/PersonTitleBox"

type HistoryListProps = {
  history?: (History | HistoryEntry)[]
}

export const HistoryList = (props: HistoryListProps) => {
  const { history } = props

  // Handle undefined or null history
  if (!history || history.length === 0) {
    return (
      <Box sx={{ textAlign: "center", py: 4 }}>
        <Typography variant="body2" color="text.secondary">
          No audit trail entries found.
        </Typography>
      </Box>
    )
  }

  const sortedHistories = [...history].sort((b, a) => {
    return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
  })

  return (
    <>
      {sortedHistories.map((item) => (
        <Card key={item.id} sx={{ mt: 1 }}>
          <CardHeader
            sx={{ py: 0.5 }}
            title={
              <PersonTitleBox createdAt={item.createdAt} person={item.createdBy || undefined} />
            }
          />
          <CardContent sx={{ py: 0 }}>
            {item.description.map((description, index) => {
              if (description.startsWith("ImageURL:")) {
                const imageUrls = description.replace("ImageURL:", "").trim().split("','")
                return (
                  <Box key={`${item.id}-${index}`} sx={{ textAlign: "center", my: 2 }}>
                    <ImageList cols={4} rowHeight={75}>
                      {imageUrls.map((url, idx) => (
                        <ImageListItem key={idx}>
                          <img
                            src={url}
                            alt={`Description  ${idx}`}
                            style={{ maxWidth: "100%", maxHeight: "75px" }}
                          />
                        </ImageListItem>
                      ))}
                    </ImageList>
                  </Box>
                )
              }
              return (
                <Typography variant="body2" key={`${item.id}-${index}`}>
                  {description}
                </Typography>
              )
            })}
          </CardContent>
        </Card>
      ))}
    </>
  )
}
